// extracted by mini-css-extract-plugin
export default {"difficulties":"simon_difficulties__tuePI","difficultyButton":"simon_difficultyButton__zN8R6","difficultiesList":"simon_difficultiesList__4AxeM"};